import {
  WhatsappComponentTemplate,
  prisma,
  WhatsappFormTemplate,
  ResourceType,
  ActionType,
} from "client";

export interface WhatsappFormStateInput extends WhatsappFormTemplate {
  components: WhatsappComponentTemplate[];
}

// CREATE
export const createWhatsappTemplate = async (
  userId: string,
  data: WhatsappFormStateInput
) => {
  try {
        // Create components first
    const createdComponents: WhatsappComponentTemplate[] = [];
    for (let component of data.components) {
      const createdComponent = await prisma.whatsappComponentTemplate.create({
        data: component as any,
      });
      createdComponents.push(createdComponent);
    }

    // Then create the form with the created components
    const template = await prisma.whatsappFormTemplate.create({
      data: {
        ...data,
        components: {
          connect: createdComponents.map((component) => ({ id: component.id })),
        },
        notificationTemplateId: data.notificationTemplateId, // This line is updated
      },
    });
    return { template };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllWhatsappTemplates = async (
  userId: string
): Promise<{
  templates?: WhatsappFormTemplate[];
  error?: any;
}> => {
  try {
        const templates = await prisma.whatsappFormTemplate.findMany();
    // get the components related to the template
    // and add them to the template object

    const templatesWithComponents = templates.map((template) => {
      return {
        ...template,
        components: [],
      };
    });

    for (let template of templatesWithComponents) {
      const components = await prisma.whatsappComponentTemplate.findMany({
        where: { formId: template.id }, // Update the field name to "formId"
      });
      template.components = components as any;
    }

    return { templates };
  } catch (error) {
    return { error };
  }
};

export const getAllWhatsappTemplateDataWithNotificationTemplateData = async (
  userId: string
) => {
  try {
        const templates = await prisma.whatsappFormTemplate.findMany();
    const withNotification: any[] = [];

    for (let template of templates) {
      const notificationTemplate = await prisma.notificationTemplate.findUnique(
        {
          where: { id: template.notificationTemplateId },
        }
      );
      withNotification.push({
        ...template,
        notificationTemplate,
      });
    }

    return { templates: withNotification };
  } catch (error) {
    return { error };
  }
};

export const getWhatsappTemplateById = async (id: string) => {
  return await prisma.whatsappFormTemplate.findUnique({
    where: { id },
  });
};

export const getWhatsappTemplateBynotificationTemplateId = async (
  notificationTemplateId: string
) => {
  try {
    const template = (await prisma.whatsappFormTemplate.findUnique({
      where: { notificationTemplateId },
    })) as any;
    const components = await prisma.whatsappComponentTemplate.findMany({
      where: { formId: template.id },
    });
    let comp: any = {};
    components.forEach((component) => {
      comp[component.type.toLowerCase()] = component;
    });

    let WhatsappTemplate: any = template;
    WhatsappTemplate.component = comp;
    WhatsappTemplate.languages = [WhatsappTemplate.language];

    return { WhatsappTemplate };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateWhatsappTemplateById = async (
  userid: string,
  id: string,
  data: WhatsappFormTemplate
) => {
  try {
        return await prisma.whatsappFormTemplate.update({
      where: { id },
      data: {
        ...data,
        notificationTemplateId: data.notificationTemplateId,
      },
    });
  } catch (error) {
    return { error };
  }
};

// DELETE
export const deleteWhatsappTemplateById = async (
  userId: string,
  id: string
) => {
  try {
        return await prisma.whatsappFormTemplate.delete({
      where: { id },
    });
  } catch (error) {
    return { error };
  }
};
